// extracted by mini-css-extract-plugin
module.exports = {"categorySquare":"categorySquare_categorySquare__1cFir","categoryText":"categorySquare_categoryText__x9aet"};